module.exports = __webpack_public_path__ + "static/img/logo_3.dbb8c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_3.png
// module id = +iNW
// module chunks = 0